import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import AxisEditForm from '../../elements/axis/form';
import Loading from './../../elements/loading';
import AxisAdd from './../../elements/axis/widget/axis_add';

class AxisEdit extends Component {
	render() {
		const { axis} = this.props;
		return (
			axis.isFetching ? <Loading/>:<AxisEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.reset('axis.edit');
	}
}

export default BaseLayout(AxisEdit, {
	title:"Crear eje",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AxisAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/axis/create.jsx